namespace appn { 

    export enum RESTFormat {
        json = 'Json',
        xml = 'Xml',
        urlEncoded = 'UrlEncoded',
        rawJson = 'RawJson',
        rawXml = 'RawXml'
    } 

    export enum UserType {
        full = 'Full',
        premium = 'Premium',
        standard = 'Standard',
        edge = 'Edge',
        pro = 'Pro'
    }

    export interface KeyValue {
        key: string;
        val: string;
        index: number;
    }

    export interface RowSortOrder {
        type: RowSortType;
        header: number;
    }

    export enum RowSortType {
        asc = 'Asc',
        desc = 'Desc',
        none = 'None'
    }
    
    export enum ScreenType {
        form = 'Form',
        listing = 'Listing',
        detail = 'Detail',
        iconBoard = 'IconBoard',
        mapping = 'Mapping'
    }

    export type JsonSchemaDataType = 'string' | 'number' | 'boolean' | 'array' | 'object';
} 
